export default __webpack_public_path__ + "assets/lesson/0302/animation.4e56117819b4b461e96ba64df971990e.png";